<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";

export default {
    name: "BreadCrumbForum",
    components: {
        AjaxLoad,
    },
    data() {
        return {
            forum: null,
        }
    },
    computed: {
        breadcrumb() {
            return this.hasForum && {
                text: this.forum?.NAME_FULL?.VALUE,
            };
        },
        hasForum() {
            return !!parseInt(this.$route.params.ID_FORUM);
        },
    },
    beforeDestroy() {
        this.$store.commit('UPDATE_BREAD_CRUMBS', {forum: null});
    },
}
</script>

<template>
    <ajax-load
        v-model="forum"
        :active="hasForum"
        :url="$apiUrl.getForumUrl($route.params)"
        :transform="response => response.data.data.items[0]"
        @input="$store.commit('UPDATE_BREAD_CRUMBS', {forum: $event})"
    >
        <router-view></router-view>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
